// Every key starts with 'partners', so invalidating ['partners']
// reaches every partners query. Paged lists and single-partner lookups
// cache different shapes, so each has its own second segment.
export const partnerQueryKeys = {
  // Paged list (`useInfiniteScroll`), cached as `{ pages, pageParams }`
  // and keyed by the params object it sends, names included.
  infinite: (params: object) =>
    ['partners', 'infinite', params] as const,
  // One partner, fetched as `fetchPartners({ partner_ids: [id] })`.
  detail: (partnerId: string | null | undefined) =>
    ['partners', 'detail', partnerId] as const,
} as const;
